import {
    browserTracingIntegration,
    captureException,
    captureFeedback,
    init as sentryInit,
    setUser as sentrySetUser,
} from '@sentry/browser';

window.Sentry = {
    browserTracingIntegration,
    captureException,
    captureFeedback,
    init: sentryInit,
    setUser: sentrySetUser,
};

import _ from 'lodash';
window._ = _;

// Bootstrap 5 JS is loaded as a synchronous vendor script in chrome.blade.php
// (public/js/vendor/bootstrap.bundle.min.js) so window.bootstrap is already
// defined before this Vite module runs. No import needed here.

import jq from 'jquery';
// Reuse the synchronously-loaded jQuery instance so Axios CSRF setup and any
// remaining code in this module uses the same $ as inline blade scripts.
// jquery-mask-plugin, bootstrap-datepicker, tagsinput, and DataTables are all
// loaded as sync vendor scripts in chrome.blade.php — do NOT import them here
// or they will register on the bundled jQuery instance instead of window.jQuery.
const $ = window.jQuery ?? jq;
window.$ = window.jQuery = $;

import ipaddr from 'ipaddr.js/ipaddr.min';
window.ipaddr = ipaddr;

import axios from 'axios';
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
    $.ajaxSetup({ headers: { 'X-CSRF-TOKEN': token.content } });
} else {
    console.error('CSRF token not found');
}
